import React from "react"
import { FormField } from "src/features/calculator/components/field/FormField"
import styled from "styled-components"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { CalculationSchema } from "src/features/calculator/schema"

type Props = {
  remittance: number
  totalReimbursement: number
  setValue: UseFormSetValue<CalculationSchema>
  errors: FieldErrors<CalculationSchema>
}

export function RemittanceEqualReimbursementRow({
  remittance,
  totalReimbursement,
  setValue,
  errors,
}: Props) {
  return (
    <StyledCalculatorRowDiv>
      <FormField
        label="立替金送金額"
        type="number"
        placeholder="Placeholder"
        hint={`${remittance.toLocaleString()}円`}
        disabled
        value={remittance}
      />
      <span>=</span>
      <FormField
        label="立替元本"
        type="number"
        placeholder="Placeholder"
        hint={`${totalReimbursement.toLocaleString()}円`}
        onChange={(e) => {
          setValue("totalReimbursement", Number(e.target.value))
        }}
        errorText={errors?.totalReimbursement?.message}
        value={totalReimbursement}
      />
    </StyledCalculatorRowDiv>
  )
}

const StyledCalculatorRowDiv = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`
